import styled from 'styled-components';
import { StatusTone } from 'screening/statusLabels';

type CalloutTone = StatusTone;

const washFor = (tone?: CalloutTone) => {
  switch (tone) {
    case 'advance':
      return 'var(--screening-advance-wash)';
    case 'hold':
      return 'var(--screening-hold-wash)';
    case 'reject':
      return 'var(--screening-reject-wash)';
    default:
      return 'var(--screening-canvas)';
  }
};

/**
 * A quiet tinted-wash block. Replaces the coloured left-rail device: emphasis
 * comes from a full desaturated wash and a hairline border, never a bar. Pair
 * with a StatusChip when the tone needs to be named.
 */
export const Callout = styled.div<{ $tone?: CalloutTone; $tight?: boolean }>`
  background: ${({ $tone }) => washFor($tone)};
  border: 1px solid var(--screening-hairline);
  border-radius: var(--screening-r-card);
  padding: ${({ $tight }) => ($tight ? '10px 14px' : '16px 18px')};
`;

export default Callout;
